export default __webpack_public_path__ + "static/media/image-main-2-m.604fa1f7.webp";